export default __webpack_public_path__ + "static/media/user_icon.ddaaf818.svg";